import { sharedE7AudienceData } from './shared-product-data/e7Audience.mjs';
"use strict";
const e7Audience = {
  ...sharedE7AudienceData
};
export { e7Audience };
//# sourceMappingURL=e7Audience.mjs.map
